export default "/_next/static/chunks/fonts/Funnel Display Bold-045e2dac8a1cf8847133631caed65cfb.ttf";